import { WorkItem } from '../work-item'

export class WorkItemCommand {
  constructor(
    public itemId: string,
    public type: WorkItemCommandType
  ) {}
}

export enum WorkItemCommandType {
  PREPARE = 'PREPARE',

  CALCULATE_BOMS = 'CALCULATE_BOMS',

  PACKAGE_CLEANUP = 'PACKAGE_CLEANUP',

  ENRICH_SEGMENTS = 'ENRICH_SEGMENTS',
}

export class WorkItemCommandResult {
  public item: WorkItem
  public success: boolean
  public message: string
}
